module.exports = __webpack_public_path__ + "img/黃梓生_23-01.462a664f.jpg";